import { findCurrentAgencies } from "../report/reportActions";

export const transformDataCollectionInput = (values, taskKey) => (state) => {
  const agency = findCurrentAgencies(state, values.AgencyKeys);
  const transactionDates = [
    values.TransactionDate[0],
    values.TransactionDate[1],
  ];
  return {
    ...values,
    AgencyNameAndNumber: agency.FullName,
    FileName: `CustomerDataCollection_${agency.Number}`,
    TransactionDate: transactionDates,
    ProducersTaskKey: taskKey,
  };
};
